import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TOKENS } from "@/lib/tokens";

const LANGS = ["es", "en", "de"] as const;
type Lang = (typeof LANGS)[number];

const STORAGE_KEY = "talenta.lang";

export function LanguageChips() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY) as Lang | null;
    if (saved && LANGS.includes(saved) && i18n.language !== saved) {
      i18n.changeLanguage(saved);
    }
  }, [i18n]);

  function pick(lng: Lang) {
    i18n.changeLanguage(lng);
    localStorage.setItem(STORAGE_KEY, lng);
  }

  return (
    <div className="inline-flex gap-1 sm:gap-2" role="group" aria-label="Language selector">
      {LANGS.map((lng) => {
        const active = i18n.language?.startsWith(lng) ?? false;
        return (
          <button
            key={lng}
            type="button"
            onClick={() => pick(lng)}
            aria-pressed={active}
            className="rounded-md text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2"
            style={{
              height: "44px",
              minWidth: "44px",
              padding: "0 10px",
              cursor: "pointer",
              border: `1px solid ${active ? TOKENS.primary : TOKENS.border}`,
              backgroundColor: active ? TOKENS.primary : TOKENS.surfaceElevated,
              color: active ? TOKENS.primaryFg : TOKENS.text,
              outlineColor: TOKENS.primary,
            }}
          >
            {lng.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
